import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
  Paper,
  useMediaQuery,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import CustomDatePicker from "../utilities/CustomDatePicker";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import FuseUtils from "@fuse/utils/FuseUtils";
import moment from "moment";
import Draggable from "react-draggable";
import { useTheme } from "@mui/material/styles";
const statusOptions = [
  { value: "OPEN", label: "Open" },
  { value: "CLOSE", label: "Close" },
  {
    value: "BOOKING_REQUEST_SENT_TO_FACTORY",
    label: "Booking request sent to factory",
  },
  {
    value: "BOOKING_REQUEST_SENT_TO_NFZE",
    label: "Booking request sent to NFZE",
  },
  {
    value: "BOOKING_REQUEST_SENT_TO_GERMANY",
    label: "Booking request sent to germany",
  },
  { value: "CLEAN_TO_ISSUE_PI", label: "Clean to Issue PI" },
  { value: "BOOKED", label: "Booked" },
  { value: "READY_TO_RELEASE", label: "Ready to Release" },
  { value: "RELEASED", label: "Released" },
  { value: "LOADED", label: "Loaded" },
];
const getDateUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getDateFromyear}`;

function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"], button'}
      disabled={isMobile}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}
export default function AddContainerDialog(props) {
  const {
    open,
    onClose,
    containerTypeOptions,
    regionOptions,
    loadingWeekOptions,
    handleSubmit,
    checkSubmit,
    generateId,
    filteredLoadingWeek,
    hasPartner,
    selectedCompanyId,
    hasSuperRole,
  } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [loadingWeek, setLoadingWeek] = useState();
  const [destination, setDestination] = useState();
  const [status, setStatus] = useState({ value: "OPEN", label: "Open" });
  const [containerType, setContainerType] = useState({});
  const [forwarderName, setForwarderName] = useState();
  const [forwarderEmail, setForwarderEmail] = useState();
  const [forwarderNumber, setForwarderNumber] = useState();
  const [comment, setComment] = useState();
  const [validError, setValidError] = useState({});
  const [cutOffDate, setCutOffDate] = useState(null);
  const [btnDisable, setBtnDisable] = useState(true);
  const [weekOption, setWeekOption] = useState([]);
  // const [portOptions,setPortOptions]=useState();

  const getLoadingWeekList = async () => {
    const highestWeekObject = filteredLoadingWeek.reduce((prev, current) => {
      if (current.year > prev.year) return current;
      if (current.year === prev.year && current.week > prev.week)
        return current;
      return prev;
    });
    const defaultWeek = highestWeekObject.week;
    const currentYears = highestWeekObject.year;
    let adjustedWeek = defaultWeek;
    let adjustedYear = currentYears;

    if (hasSuperRole) {
      adjustedWeek = defaultWeek - 1;

      if (adjustedWeek < 1) {
        adjustedYear = currentYears - 1;
        adjustedWeek = moment(`${adjustedYear}-01-01`).isoWeeksInYear();
      }
    }
    const generateDateStrings = (startYear, defaultWeek) => {
      const result = [];
      const disabledWeeks = [31, 32, 33];
      for (let year = startYear; year <= startYear + 4; year++) {
        const maxWeek = moment(`${year}-01-01`).isoWeeksInYear();
        const startWeek = year === startYear ? defaultWeek : 1;

        for (let week = startWeek; week <= maxWeek; week++) {
          result.push({
            value: week,
            label: `${week}/${year}`,
            year,
            isDisabled: disabledWeeks.includes(week),
          });
        }
      }

      return result;
    };

    const weekOption = generateDateStrings(adjustedYear, adjustedWeek);

    setWeekOption(weekOption);
  };

  // function getStartDateOfWeek(year, weekNumber) {
  //   var startDate = new Date(year, 0, 1);
  //   var firstDay = startDate.getDay();
  //   var daysToFirstMonday = (8 - firstDay) % 7;
  //   var daysToRequestedWeek = (weekNumber - 1) * 7 + daysToFirstMonday;
  //   startDate.setDate(startDate.getDate() + daysToRequestedWeek);
  //   startDate.setDate(startDate.getDate() - 24);
  //   const cutOff = startDate;//moment(startDate).format("DD-MM-yyyy")
  //   setCutOffDate(cutOff)
  // }
  const getStartDateOfWeek = async (year, week) => {
    const list = await OAuthService.getList(
      `${getDateUrl}?week=${week}&year=${year}`,
    );
    const data = moment(list.data).subtract(3, "weeks").format("YYYY-MM-DD");
    setCutOffDate(data);
  };
  useEffect(() => {
    if (open) {
      getLoadingWeekList();
      // const portsData = regionOptions.map((port) => {
      //   return {
      //     value: port.portCode,
      //     label: port.displayName,
      //   };
      // });
      // setPortOptions(portsData)
    }
  }, [open]);
  const handleClose = () => {
    onClose();
    setContainerType();
    setLoadingWeek();
    setDestination();
    setForwarderEmail();
    setForwarderName();
    setForwarderNumber();
    setCutOffDate();
    setComment();
  };
  const handleSaveContainer = () => {
    handleSubmit({
      loadingWeek,
      containerType,
      status,
      cutOffDate,
      destination,
      comment,
      forwarderName,
      forwarderEmail,
      forwarderNumber,
    });
    setContainerType();
    setLoadingWeek();
    setDestination();
    setForwarderEmail();
    setForwarderName();
    setForwarderNumber();
    setCutOffDate();
    setComment();
  };

  useEffect(() => {
    if (loadingWeek) {
      getStartDateOfWeek(loadingWeek.year, loadingWeek.value);
    }
  }, [loadingWeek]);
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="xs"
        fullScreen={isMobile}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <AppBar
          color="secondary"
          position="static"
          sx={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              New Container Plan
            </Typography>
            <IconButton onClick={handleClose} color="inherit">
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          <Grid container xs={12} spacing={2}>
            <Grid item xs={12} md={6}>
              {/* <label>Container No.</label>
              <div className="mb-10">
              <TextField
                fullWidth
                variant="outlined"
                type="number"
                disabled
                // value={generateId}
              /></div> */}
              <label>
                Container Type{" "}
                <Typography component="span" color="error">
                  *
                </Typography>
              </label>
              <div className="mb-10">
                <Select
                  value={containerType}
                  onChange={(event) =>
                    setContainerType({ value: event.value, label: event.label })
                  }
                  options={containerTypeOptions}
                  styles={customStyles(
                    ((checkSubmit && !containerType) ||
                      validError.containerType) &&
                      "#f44336",
                  )}
                  className="w-full mb-10"
                />
                <Typography color="error" className="text-sm ml-14">
                  {checkSubmit && !containerType
                    ? "This field is required"
                    : validError.containerType}
                </Typography>
              </div>
              <label>
                Loading Week <span style={{ color: "red" }}>*</span>
              </label>
              <div className="mb-10">
                <Select
                  value={loadingWeek}
                  onChange={(event) =>
                    setLoadingWeek({
                      value: event.value,
                      label: event.label,
                      year: event.year,
                    })
                  }
                  options={weekOption}
                  className="w-full"
                  styles={customStyles(
                    ((checkSubmit && !loadingWeek) || validError.loadingWeek) &&
                      "#f44336",
                  )}
                />
                <Typography color="error" className="text-sm ml-14">
                  {checkSubmit && !loadingWeek
                    ? "This field is required"
                    : validError.loadingWeek}
                </Typography>
              </div>
              <label>Cut off Date</label>
              <div>
                {hasPartner ? (
                  <TextField
                    fullWidth
                    value={
                      cutOffDate ? moment(cutOffDate).format("DD-MM-YYYY") : ""
                    }
                    name="cutOffDate"
                    variant="outlined"
                    type="text"
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                ) : (
                  <CustomDatePicker
                    className="w-full"
                    format="dd-MM-yyyy"
                    name="cutOffDate"
                    value={cutOffDate}
                    onChange={(date) => setCutOffDate(date)}
                  />
                )}
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <label>Status</label>
              <div className="mb-10">
                <Select
                  value={status}
                  onChange={(event) =>
                    setStatus({
                      value: event.value,
                      label: event.label,
                    })
                  }
                  options={statusOptions}
                  styles={customStyles(
                    ((checkSubmit && !status) || validError.status) &&
                      "#f44336",
                  )}
                  className="w-full"
                  isDisabled
                 
                />
                <Typography color="error" className="text-sm ml-14">
                  {checkSubmit && !status
                    ? "This field is required"
                    : validError.status}
                </Typography>
              </div>
              <label>
                Destination / Region <span style={{ color: "red" }}>*</span>
              </label>
              <div>
                <Select
                  value={destination}
                  onChange={(event) =>
                    setDestination({ value: event.value, label: event.label })
                  }
                 
                  options={regionOptions}
                  // options={hasPartner?regionOptions:(selectedCompanyId !=="all")?regionOptions:portOptions}
                  styles={customStyles(
                    ((checkSubmit && !destination) || validError.destination) &&
                      "#f44336",
                  )}
                  className="w-full"
                />
                <Typography color="error" className="text-sm ml-14">
                  {checkSubmit && !destination
                    ? "This field is required"
                    : validError.destination}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12}>
              <label>Forwarder</label>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Name"
                    value={forwarderName}
                    onChange={(event) => setForwarderName(event.target.value)}
                    variant="outlined"
                    type="text"
                    size="small"
                    autoComplete="new-password"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Contact Number"
                    value={forwarderNumber}
                    onChange={(event) => setForwarderNumber(event.target.value)}
                    variant="outlined"
                    type="text"
                    size="small"
                    autoComplete="new-password"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Email"
                    value={forwarderEmail}
                    onChange={(event) => setForwarderEmail(event.target.value)}
                    variant="outlined"
                    type="email"
                    size="small"
                    autoComplete="new-password"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <label>Comment</label>
              <div>
                <TextField
                  fullWidth
                  value={comment}
                  onChange={(event) => setComment(event.target.value)}
                  variant="outlined"
                  type="text"
                />
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            variant="contained"
            startIcon={<FuseSvgIcon>material-outline:save</FuseSvgIcon>}
            onClick={handleSaveContainer}
            disabled={
              containerType && destination && loadingWeek ? false : true
            }
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
